
























import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import GachaRadio from "../common/GachaRadio.vue";
import store from "@/store";

@Component({
  components: {
    "gacha-radio": GachaRadio
  }
})
export default class DrawsSettings extends Vue {
  get gachaTypeParameter() {
    return store.getters.gachaTypeParameter;
  }
}
